/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderMarketPositioningMapViewCustomItem', 'model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderMarketPositioningMapViewCustomItem'), require('../model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderMarketPositioningMapViewCustomItemApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewCustomItem, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewCustomItemPaginationSlice);
  }
}(this, function(ApiClient, StakeholderMarketPositioningMapViewCustomItem, StakeholderMarketPositioningMapViewCustomItemPaginationSlice) {
  'use strict';

  /**
   * StakeholderMarketPositioningMapViewCustomItem service.
   * @module api/StakeholderMarketPositioningMapViewCustomItemApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderMarketPositioningMapViewCustomItemApi. 
   * @alias module:api/StakeholderMarketPositioningMapViewCustomItemApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewCustomItemAddAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewCustomItem>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.stakeholderMarketPositioningMapViewCustomItemAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewCustomItemAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewCustomItemAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewCustomItem/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewCustomItemDeleteAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewCustomItemDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewCustomItemDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewCustomItemDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewCustomItem/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewCustomItemEditAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewCustomItem>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewCustomItemEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewCustomItemEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewCustomItemEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewCustomItem/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewCustomItemSearchSlicePut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapViewCustomItem} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StakeholderMarketPositioningMapViewCustomItemApi~stakeholderMarketPositioningMapViewCustomItemSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice}
     */
    this.stakeholderMarketPositioningMapViewCustomItemSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewCustomItemSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewCustomItemSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderMarketPositioningMapViewCustomItemPaginationSlice;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewCustomItem/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
